module.exports = __webpack_public_path__ + "img/banner_jhb_h53.7e1c8106.png";